import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Empty, Input, message, Row, Select, Statistic, Table } from 'antd';
import axios from '../utils/axios';

const metrics = [['doctors', '医生人数'], ['participants', '参与人数'], ['submitted', '提交份数'], ['pending', '待审核'], ['approved', '审核通过'], ['rejected', '已驳回'], ['confirmed', '已确认'], ['settled', '已结算'], ['paid', '已支付']];
export const ProgressPanel: React.FC<{ projectId: number }> = ({ projectId }) => {
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('');
  useEffect(() => {
    let current = true;
    setLoading(true); setData(undefined);
    axios.get(`/project-access/${projectId}/progress`).then(r => { if (current) setData(r.data.data); }).catch(() => message.error('获取项目进度失败')).finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [projectId]);
  const search = (rows: any[]): any[] => rows.flatMap(row => {
    if (row.name.includes(filter)) return [row];
    const children = search(row.children || []);
    return children.length ? [{ ...row, children }] : [];
  });
  return <>
    <Row gutter={[12, 12]}>{metrics.map(([key, label]) => <Col xs={12} md={8} lg={6} key={key}><Card loading={loading}><Statistic title={label} value={data?.[key] || 0} /></Card></Col>)}</Row>
    <Alert style={{ margin: '16px 0' }} type="info" message="人数按医生去重；通过份数包含已确认、已结算和已支付记录。缺少层级归属的记录计入“未分配”。" />
    <Input.Search placeholder="搜索层级名称或维度值" allowClear value={filter} onChange={e => setFilter(e.target.value)} style={{ maxWidth: 360, marginBottom: 16 }} />
    <Table loading={loading} rowKey="key" dataSource={search(data?.children || [])} pagination={false} scroll={{ x: 1100 }} columns={[{ title: '层级维度（展开查看下级）', dataIndex: 'name', width: 270 }, ...metrics.map(([key, label]) => ({ title: label, dataIndex: key, width: 100 }))]} locale={{ emptyText: '项目未配置层级，或暂无层级数据' }} />
  </>;
};
const ProjectProgress: React.FC = () => {
  const [projects, setProjects] = useState<any[]>([]);
  const [id, setId] = useState<number>();
  useEffect(() => { axios.get('/project-access').then(r => { setProjects(r.data.data); setId(r.data.data[0]?.id); }).catch(() => message.error('获取项目失败')); }, []);
  return <><h2>项目进度</h2><Select showSearch optionFilterProp="label" placeholder="选择项目" value={id} onChange={setId} style={{ width: '100%', maxWidth: 460, marginBottom: 20 }} options={projects.map(p => ({ value: p.id, label: p.name }))} />{id ? <ProgressPanel projectId={id} /> : <Empty description="暂无可查看的项目" />}</>;
};
export default ProjectProgress;
